export default {"src":"/_next/static/media/wallet.34de59fa.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};